import {NgModule} from '@angular/core';
import {LanguageSelectionComponent} from './components/language.selection/language.selection.component';
import {LanguageSelectionItemComponent} from './components/language.selection.item/language.selection.item.component';
import {TranslateModule} from './translate.module';
import {CommonModule} from '@angular/common';
import {TooltipModule} from '../tooltip/tooltip.module';
import {ClickOutModule} from '../directives/click.out/click.out.module';
import {ClickableElementModule} from "../directives/clickable.element/clickable.element.module";

@NgModule({
  declarations: [
    LanguageSelectionComponent,
    LanguageSelectionItemComponent
  ],
	imports: [
		TranslateModule,
		CommonModule,
		TooltipModule,
		ClickOutModule,
		ClickableElementModule
	],
  exports: [
    LanguageSelectionComponent,
    LanguageSelectionItemComponent
  ]
})
export class LanguageSelectionModule { }
